module.exports = __webpack_public_path__ + "img/bab1b04.jpg";